import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ventura/ventura/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`TODO: Display logo`}</p>
    <h1 {...{
      "id": "ventura-react-component-library"
    }}>{`Ventura React component library`}</h1>
    <p><img alt="GitHub Workflow Status" src="https://img.shields.io/github/workflow/status/kodiak-packages/ventura/Test%20and%20lint/master?label=CI%20test%2Flint" />{` `}<img alt="GitHub Workflow Status" src="https://img.shields.io/github/workflow/status/kodiak-packages/ventura/Build%20and%20release/master?label=CI%20build%2Frelease" />{` `}<a parentName="p" {...{
        "href": "https://codecov.io/gh/kodiak-packages/bloodhound"
      }}><img alt="codecov" src="https://codecov.io/gh/kodiak-packages/ventura/branch/master/graph/badge.svg?token=2CWDA87EE2" /></a>{` `}<img alt="Snyk Vulnerabilities for GitHub Repo" src="https://img.shields.io/snyk/vulnerabilities/github/kodiak-packages/ventura" />{` `}<img alt="npm" src="https://img.shields.io/npm/v/ventura" />{` `}<img alt="Code style" src="https://img.shields.io/badge/code_style-prettier-ff69b4.svg" /></p>
    <p>{`A lightweight, themable react component library from 2020`}</p>
    <ul>
      <li parentName="ul">{`📘 Typescript support`}</li>
      <li parentName="ul">{`🎨 Theme with CSS variables`}</li>
      <li parentName="ul">{`📎 All components support className and ref props`}</li>
      <li parentName="ul">{`🐦 Icons from `}<a parentName="li" {...{
          "href": "https://feathericons.com"
        }}>{`Feather Icons`}</a></li>
    </ul>
    <h2 {...{
      "id": "documentation"
    }}>{`Documentation`}</h2>
    <p>{`You can find examples of all of our components in the documentation.`}</p>
    <p><a parentName="p" {...{
        "href": "https://kodiak-packages.github.io/ventura"
      }}>{`➡️ Go to full documentation`}</a></p>
    <p>{`This library is documented using `}<a parentName="p" {...{
        "href": "https://www.docz.site/"
      }}>{`Docz`}</a>{`.`}</p>
    <h2 {...{
      "id": "getting-started"
    }}>{`Getting started`}</h2>
    <pre><code parentName="pre" {...{}}>{`yarn add ventura
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`npm install ventura
`}</code></pre>
    <h3 {...{
      "id": "usage"
    }}>{`Usage`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Button } from 'ventura';

const MyComponent = () => {
  return <Button>Click me</Button>;
};
`}</code></pre>
    <h2 {...{
      "id": "theming"
    }}>{`Theming`}</h2>
    <p>{`TODO`}</p>
    <h2 {...{
      "id": "browser-support"
    }}>{`Browser support`}</h2>
    <p>{`TODO`}</p>
    <h2 {...{
      "id": "contributing"
    }}>{`Contributing`}</h2>
    <p>{`TODO`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      